import { useSalesServiceSalesProductsListKey } from '@insurance/api/queries'
import { SalesService } from '@insurance/api/requests'
import { InfiniteSelect } from '@shared/components'
import { useSessionContext } from '@shared/hooks'
import { SelectProps } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  useCode?: boolean
  code?: string[]
  defaultValue?: string
  excludeIds?: string[]
  availableToBrokers?: boolean
} & SelectProps

export const ProductSelect = ({
  useCode,
  code,
  defaultValue,
  excludeIds,
  availableToBrokers,
  ...props
}: Props) => {
  const { t } = useTranslation()
  const { broker } = useSessionContext()

  if (broker) return null

  const excludeIdsString = excludeIds
    ?.filter((id) => String(id) !== String(defaultValue))
    .join(',')

  return (
    <InfiniteSelect
      placeholder={t('select_product')}
      apiCall={({ pageParam, pageSize, search }) =>
        SalesService.salesProductsList(
          typeof availableToBrokers === 'boolean'
            ? availableToBrokers
            : undefined,
          code,
          excludeIdsString,
          undefined,
          undefined,
          pageParam,
          pageSize,
          search
        )
      }
      queryKey={[
        useSalesServiceSalesProductsListKey,
        { code, excludeIdsString, availableToBrokers }
      ]}
      getOption={({ name, id, code }) => ({
        label: name,
        value: String(useCode ? code : id)
      })}
      style={{ minWidth: 200 }}
      {...props}
    />
  )
}
